import { IonContent, IonPage, IonToolbar, IonTitle } from '@ionic/react';
import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { ChannelTimeline } from './components/ChannelTimeline';
import { ChannelsHeaderActions } from './components/ChannelsHeaderActions';

export const ChannelsTab = () => {
  return (
    <IonPage>
      <AppSectionHeader variant="main">
        <IonToolbar>
          <IonTitle className="ml-4">Canales</IonTitle>
        </IonToolbar>
      </AppSectionHeader>
      <ChannelsHeaderActions />
      <IonContent className="ion-padding">
        <ChannelTimeline />
      </IonContent>
    </IonPage>
  );
};
